<template>
        <v-dialog v-model="dialog" width="750px">
            <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" text style="color:#F15A24" @click="openTermos = true">Política de Privacidade</span>
            </template>
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    {{termo.titulo}}
                </v-card-title>

                <v-card-text class="mt-3" v-html="termo.texto">
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#F15A24" text @click="dialog = false">
                        Eu aceito
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import { fetchPrivacyPolicy } from '../utils/privacidadePolicy';

export default {
    data() {
        return {
            dialog: false,
            termo: { titulo: "", texto: ""}
        }
    },
    async mounted() {
        this.termo = await fetchPrivacyPolicy(this.$http);
    }
}
</script>
